<template>
  <div>
    <b-form-group
      :label="`${data.label.text} ${setRequiredMarkerToLabel(data.fields)}`"
      label-cols="md-4"
      :description="data.label.description"
      :label-for="data.label.for"
      :key="data.label.text"
      v-if="isMMUFieldVisisble(data.label.for)">

      <template v-for="field in data.fields">
        <b-checkbox
          v-if="isCheckboxField(field) && finalApplicationType !== 'WV'"
          :tab="tab"
          :key="field.id"
          :className="getColSizes(field)"
          :id="field.id"
          :type="getFieldType(field)"
          :value="field.defaultValue"
          :placeholder="field.placeholder"
          :field="field.id"
          :rules="field.rule"
          :labelText="field.appendedText"
          :helpText="field.helpText"
        />
      </template>

      <b-input-group>
        <template v-for="field in data.fields">
          <b-text
            v-if="isBasicField(field) && field.id"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :placeholder="field.placeholder"
            :field="field.id"
            :rules="field.rule"
            :appendText="field.appendedText"
            :helpText="field.helpText"
            :format="field.format"
          />
          <b-text-area
            v-if="isLongTextField(field) && field.id"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :placeholder="field.placeholder"
            :field="field.id"
            :rules="field.rule"
            :appendText="field.appendedText"
            :helpText="field.helpText"
            :format="field.format"
          />
          <b-number
            v-if="isNumberField(field) && field.id"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            type="number"
            :placeholder="field.placeholder"
            :field="field.id"
            :rules="field.rule"
            :appendText="field.appendedText"
            :helpText="field.helpText"
            :format="field.format"
          />
          <b-radio
            v-if="isRadioField(field) || isBooleanField(field)"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :placeholder="field.placeholder"
            :field="field.id"
            :rules="field.rule"
            :defaultValues="field.defaultValue"
            :isBooleanField="isBooleanField(field)"
            :helpText="field.helpText"
          />
          <b-select
            v-if="isDropdown(field)"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :options="getDropdownOptions(field.defaultValue)"
            :field="field.id"
            :rules="field.rule"
            :helpText="field.helpText"
          />
          <b-date-time
            v-if="isDateTime(field)"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :field="field.id"
            :rules="field.rule"
            :helpText="field.helpText"
          />
          <!-- TODO: not a good solution -->
          <b-checkbox
            v-if="isCheckboxField(field) && finalApplicationType === 'WV'"
            :tab="tab"
            :key="field.id"
            :className="getColSizes(field)"
            :id="field.id"
            :type="getFieldType(field)"
            :value="field.defaultValue"
            :placeholder="field.placeholder"
            :field="field.id"
            :rules="field.rule"
            :labelText="field.appendedText"
            :helpText="field.helpText"
            style="min-width: 200px;"
          />
          <sub-fields
            v-if="hasSubFields(field)"
            :tab="tab"
            :key="field.id + 'subfield'"
            :fields="field.subFields"
          />
        </template>

      </b-input-group>

    </b-form-group>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import BText from '@/components/application/Form/FormComponents/BText.vue'
  import BNumber from '@/components/application/Form/FormComponents/BNumber.vue'
  import BSelect from '@/components/application/Form/FormComponents/BSelect.vue'
  import BRadio from '@/components/application/Form/FormComponents/BRadio.vue'
  import BCheckbox from '@/components/application/Form/FormComponents/BCheckbox.vue'
  import BDateTime from '@/components/application/Form/FormComponents/BDateTime.vue'
  import SubFields from '@/components/application/Form/FormComponents/SubFields.vue'
  import BTextArea from './BTextArea.vue'

  export default {
    components: {
      BText,
      BNumber,
      BSelect,
      BRadio,
      BCheckbox,
      BDateTime,
      SubFields,
      BTextArea
    },
    props: {
      data: {
        type: Object,
        reuired: true
      },
      tab: {
        type: String,
        required: true
      }
    },
    methods: {
      getFieldType: (field) => {
        const fieldType = field.fieldType
        let htmltype = ''
        switch (fieldType) {
        case 'text':
          htmltype = 'text'
          break
        case 'number':
          htmltype = 'number'
          break
        }
        return htmltype
      },
      isBasicField: (field) => {
        const fieldType = field.fieldType
        if (['text'].indexOf(fieldType) > -1) {
          return true
        }
        return false
      },
      isLongTextField: (field) => {
        const fieldType = field.fieldType
        if (fieldType === 'longtext') {
          return true
        }
        return false
      },
      isNumberField: field => (field.fieldType === 'number'),
      isDropdown: (field) => {
        const fieldType = field.fieldType
        if (fieldType === 'dropdown') {
          return true
        }
        return false
      },
      isCheckboxField: (field) => {
        const fieldType = field.fieldType
        if (fieldType === 'checkbox') {
          return true
        }
        return false
      },
      isRadioField: (field) => {
        const fieldType = field.fieldType
        if (fieldType === 'radio') {
          return true
        }
        return false
      },
      isBooleanField: (field) => {
        const fieldType = field.fieldType
        if (fieldType === 'boolean') {
          return true
        }
        return false
      },
      isDateTime: (field) => {
        const fieldType = field.fieldType
        if (fieldType === 'datetime' || fieldType === 'date') {
          return true
        }
        return false
      },
      hasSubFields: (field) => {
        const { subFields } = field
        return !!subFields.length
      },
      replaceQuotes: (text) => {
        return text.replace('\\"', /"/g)
      },
      getDropdownOptions (json) {
        const data = json
        const options = []
        data.forEach(element => {
          const option = {
            text: element.text,
            value: element.value
          }
          options.push(option)
        })
        return options
      },
      getSelectedDropdownOption: (json) => {
        const data = json
        return data.find((element) => {
          return element.selected
        }).value
      },
      getColSizes: (field) => {
        const sizes = field.sizes
        if (sizes !== null) {
          let css = ''
          if (sizes.col !== null) {
            css += 'col-' + sizes.col + ' '
          }

          if (sizes.colSm !== null) {
            css += 'col-sm-' + sizes.colSm + ' '
          }

          if (sizes.colMd !== null) {
            css += 'col-md-' + sizes.colMd + ' '
          }

          if (sizes.colLg !== null) {
            css += 'col-lg-' + sizes.colLg + ' '
          }

          if (sizes.colXl !== null) {
            css += 'col-xl-' + sizes.colXl + ' '
          }

          return css
        } else {
          return null
        }
      },
      setRequiredMarkerToLabel (fields) {
        if (fields.some(field => field.rule === 'required')) {
          return '*'
        }
        return ''
      },
      isMMUFieldVisisble (labelFor) {
        if (this.finalApplicationType === 'MU') {
          if (labelFor === 'VollzeitAequivalente' || labelFor === 'KostenMobilitaetskonzept') {
            if (['256', '260', '262'].includes(this.konzeptArt)) {
              return true
            }
            return false
          } else if (labelFor === 'AnzahlBetriebe' || labelFor === 'GesucheImAreal') {
            if (['257', '261', '263'].includes(this.konzeptArt)) {
              return true
            }
            return false
          }
          return true
        }
        return true
      }
    },
    computed: {
      ...mapState({
        finalApplicationType: state => state.application.createApplication.finalApplicationType,
        konzeptArt: state => state.application.createApplication.formData.gesuch.konzeptart
      })
    }
  }
</script>

<style lang="scss">
.input-group{
  .col{
    padding-left: 0;
  }
}
</style>
